import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const faqs = [
  {
    q: "What can be read with Verbatim?",
    a: "Any text you can paste or upload. Novels, news articles, song lyrics, subtitles, even a long forum thread. There's no curated content library — you bring the text.",
  },
  {
    q: "Why is there no mobile app?",
    a: "Verbatim's interface relies on a three-pane layout and mouse interactions that don't translate to a phone. Reading is a sit-down activity for me - not something on the go.",
  },
  {
    q: "Do I have to start from the very beginning?",
    a: "No. You can simply add your current Anki deck or import a previously exported vocabulary list and continue from where you left off. There's no reason to make you start over. I don't care about time spent with Verbatim, only about your reading progress.",
  },
  {
    q: "What happens to my marked words?",
    a: "They're yours. Export your full vocabulary as CSV, Anki, or JSON anytime — including which texts each word came from.",
  },
  {
    q: "Who checks if I actually know my marked words?",
    a: "Nobody. Why would I? Everything is self-paced and self-reported, because I believe that you know best. No need to input the same sentence every month; if you claim that you know a word, then you know it! (a fully optional spaced-repetition quiz mode is implemented though, if you do want to rehearse)",
  },
];

export const Faq = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 sm:py-28 border-t border-[var(--vb-border)]"
    >
      <div className="container-x grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4 reveal">
          <div className="mono-label mb-3">[ 07 · FAQ ]</div>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl tracking-tighter leading-[1.02]">
            Common
            <br />
            questions.
          </h2>
          <p className="mt-4 text-[var(--vb-muted)] text-sm">
            Missing yours? Email {""}
            {/* TODO: Replace with actual email */}
            <a
              className="text-[var(--vb-primary)] underline underline-offset-4"
              href="mailto:NOTANEMAIL"
            >
              NOTANEMAIL
            </a>
          </p>
        </div>
        <div className="lg:col-span-8 reveal">
          <Accordion
            type="single"
            collapsible
            className="w-full"
            data-testid="faq-accordion"
          >
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-[var(--vb-border)]"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="font-display text-lg sm:text-xl font-bold tracking-tight py-5 hover:no-underline hover:text-[var(--vb-primary)]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[var(--vb-muted)] text-[15px] leading-relaxed pb-5 pr-8">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
